import { render, staticRenderFns } from "./index.vue?vue&type=template&id=94e5051e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5051e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94e5051e')) {
      api.createRecord('94e5051e', component.options)
    } else {
      api.reload('94e5051e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=94e5051e&scoped=true", function () {
      api.rerender('94e5051e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/questionList/index.vue"
export default component.exports